import React from "react";
import ReactECharts from "echarts-for-react";

const ChatHeatmap = () => {
    const hours = Array.from({ length: 24 }, (_, i) => `${i}:00`);
    const days = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];

    const data = [];
    for (let day = 0; day < 7; day++) {
        for (let hour = 0; hour < 24; hour++) {
            data.push([hour, day, Math.round(Math.random() * 100)]);
        }
    }

    const option = {
        title: { text: "Chat Activity Heatmap", left: "center" },
        tooltip: { position: "top" },
        grid: { height: "70%", top: "10%" },
        xAxis: { type: "category", data: hours, splitArea: { show: true } },
        yAxis: { type: "category", data: days, splitArea: { show: true } },
        visualMap: {
            min: 0,
            max: 100,
            calculable: true,
            orient: "horizontal",
            left: "center",
            bottom: "5%"
        },
        series: [
            {
                name: "Chats",
                type: "heatmap",
                data: data.map(([h, d, v]) => [h, d, v]),
                label: { show: false },
                emphasis: { itemStyle: { shadowBlur: 10 } }
            }
        ]
    };

    return <ReactECharts className="w-100" option={option} style={{ height: 400 }} />;
};
export default ChatHeatmap;
